import { Menu, MenuItem } from "@blueprintjs/core";
import * as React from "react";

export const itemRenderer = (item, {handleClick, index, modifiers, query}) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }

  const text = item.name;
  const key = item.language;
  return (
    <MenuItem
      className={modifiers.active ? "pt-active pt-intent-primary" : null}
      key={key}
      onClick={handleClick}
      text={highlightText(text, query)}
    />
  );
};

export const itemListRenderer = ({items, itemsParentRef, renderItem}) => {
  const renderedItems = items.map(renderItem).filter(item => item != null);
  return (
    <Menu ulRef={itemsParentRef} className="select-menu">
      {renderedItems}
    </Menu>
  );
};


export const itemPredicate = (query, item) => {
  const text = item.name;
  return text.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

function highlightText(text, query) {
  let lastIndex = 0;
  const words = query
    .split(/\s+/)
    .filter(word => word.length > 0)
    .map(escapeRegExpChars);
  if (words.length === 0) {
    return [text];
  }
  const regexp = new RegExp(words.join("|"), "gi");
  const tokens = [];
  while (true) {
    const match = regexp.exec(text);
    if (!match) {
      break;
    }
    const length = match[0].length;
    const before = text.slice(lastIndex, regexp.lastIndex - length);
    if (before.length > 0) {
      tokens.push(before);
    }
    lastIndex = regexp.lastIndex;
    tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
  }
  const rest = text.slice(lastIndex);
  if (rest.length > 0) {
    tokens.push(rest);
  }
  return tokens;
}

function escapeRegExpChars(text) {
  //eslint-disable-next-line
  return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}



// WEBPACK FOOTER //
// ./src/containers/ItemSelector/select.js